const ITEMS = [
  "Verniz Gel",
  "Unhas de Gel",
  "Acrílico",
  "Pedicure Spa dos Pés",
  "Design de Sobrancelhas",
  "Depilação a Cera",
  "Depilação Laser",
  "Materiais Esterilizados",
  "Atendimento VIP",
];

export const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="bg-[#C2185B] py-4 overflow-hidden border-y border-[#A2134B]"
  >
    <div className="marquee-track">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex items-center shrink-0" aria-hidden={dup === 1}>
          {ITEMS.map((item) => (
            <span
              key={`${dup}-${item}`}
              className="flex items-center gap-6 px-6 font-serif-display italic text-lg text-white/95 whitespace-nowrap"
            >
              {item}
              <span className="text-[#F8BBD0] text-xs not-italic">♡</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
